import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'

import { AllowedPages } from '@/enums/allowedPages'
import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'

export const useBulletinStore = defineStore('bulletin', () => {
    const appStore = useAppStore()
    const unreadBulletins: Ref<number> = ref(0)

    const setUnreadBulletins = (unreadBulletin: number) => {
        unreadBulletins.value = unreadBulletin
    }

    const getUnreadBulletins = () => {
        return unreadBulletins.value
    }

    const updateUnreadBulletins = () => {
        const selectedUnit = appStore.getSelectedUnit()
        if (!appStore.getUserLoggedIn() || !selectedUnit || !appStore.getAllowedPages().includes(AllowedPages.BulletinBoard)) return

        const fetchStore = useFetchStore()
        void fetchStore.fetch(`/api/iiportal-user/v2/bulletin/unread_num/${selectedUnit.objekt_sifra}`).get().json<number>().then(({ data }) => {
            if (data.value !== null) setUnreadBulletins(data.value)
        })
    }

    return {
        unreadBulletins,
        setUnreadBulletins,
        getUnreadBulletins,
        updateUnreadBulletins
    }
})
